module.exports = __webpack_public_path__ + "img/icon-save-light2.db3bb434.svg";